import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { Mail, MessageSquare, ShieldX, Save } from "lucide-react";

interface BulkActionsBarProps {
  selectedCount: number;
  selectedContactsPreview: string;
  onSend: () => void;
  onAddToDNC: () => void;
  onSaveList?: () => void;
  sendLabel?: string;
  contactType: 'email' | 'sms';
  sendDisabled?: boolean;
  sendDisabledTooltip?: string;
}

export function BulkActionsBar({
  selectedCount,
  selectedContactsPreview,
  onSend,
  onAddToDNC,
  onSaveList,
  sendLabel,
  contactType,
  sendDisabled,
  sendDisabledTooltip,
}: BulkActionsBarProps) {
  if (selectedCount === 0) return null;

  const defaultSendLabel = contactType === 'email' ? 'Send Email' : 'Send SMS';

  const sendButton = (
    <Button
      variant="default"
      size="sm"
      onClick={onSend}
      disabled={sendDisabled}
    >
      {contactType === 'sms' ? (
        <MessageSquare className="mr-2 h-4 w-4" />
      ) : (
        <Mail className="mr-2 h-4 w-4" />
      )}
      {sendLabel || defaultSendLabel}
    </Button>
  );

  return (
    <div className="flex items-center justify-between p-3 mb-4 bg-blue-50 dark:bg-blue-950 border border-blue-200 dark:border-blue-800 rounded-lg">
      <div className="flex items-center gap-2">
        <Badge variant="secondary">
          {selectedCount} selected
        </Badge>
        <span className="text-sm text-muted-foreground">
          {selectedContactsPreview}
        </span>
      </div>
      <div className="flex items-center gap-2">
        {sendDisabled && sendDisabledTooltip ? (
          <Tooltip>
            <TooltipTrigger asChild>
              <span>{sendButton}</span>
            </TooltipTrigger>
            <TooltipContent>{sendDisabledTooltip}</TooltipContent>
          </Tooltip>
        ) : (
          sendButton
        )}
        {onSaveList && (
          <Button
            variant="outline"
            size="sm"
            onClick={onSaveList}
          >
            <Save className="mr-2 h-4 w-4" />
            Save List
          </Button>
        )}
        <Button
          variant="outline"
          size="sm"
          onClick={onAddToDNC}
        >
          <ShieldX className="mr-2 h-4 w-4" />
          Add to DNC
        </Button>
      </div>
    </div>
  );
}

